import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { AuthModule } from './auth/auth.module';
import { LayoutModule } from './core/layouts/layout.module';
import { AppRoutingModule } from './app-routing.module';
import { CoreRoutingModule } from './core/core-routing.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';
// import { Angular2CsvComponent } from 'angular2-csv';

import { AppComponent } from './app.component';
import { CoreComponent } from './core/core.component';
import { NumberOnlyDirective } from './_directives/number-only.directive';
import { ScriptLoaderService } from './_services/script-loader/script-loader.service';
import { GlobalService } from './_global/global.service';
import { BeneficiaryMasterService } from './_services/beneficiaryMaster/beneficiaryMaster.service';
import { UtilService } from './_global/util.service';
import { ExcelService } from './_services/export-excel/export-excel.service';
import { GeneratlConfigurationService } from './_services/generalConfiguration/generalConfiguration.service';
import { LeadsService } from './_services';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { ReferEarnComponent } from './core/pages/refer-earn/refer-earn.component';
import { DataTableModule } from 'primeng/primeng';
import { EmailVerifyComponent } from './core/pages/admin/emailVerify/emailVerify.component';
import { ConsumerSlabRateMasterComponent } from './core/pages/admin/Master/b2c-rate-approval/consumer-slab-rate-approval.component';
import { ProductmasterService } from './_services/productmaster/productmaster.service';
@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        AuthModule,
        LayoutModule,
        AppRoutingModule,
        CoreRoutingModule,
        PdfViewerModule,
        Ng4LoadingSpinnerModule,
        DataTableModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    declarations: [
        CoreComponent,
        AppComponent,
        NumberOnlyDirective,
        ReferEarnComponent,
        EmailVerifyComponent,
        ConsumerSlabRateMasterComponent,
    ],
    providers: [ScriptLoaderService, GlobalService, UtilService, ExcelService, GeneratlConfigurationService, LeadsService, ProductmasterService],
    bootstrap: [AppComponent]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts